import React from 'react';
import { filter } from 'lodash';
import { mount } from './mount';

export const Slider = mount('app-slider', props => {
  const [ _, className, inner ] = /^\s*<div.*?class="(.*?)".*?>([\s\S]*)<\/div>\s*$/.exec(props.innerHTML) || [];
  return (
    <div className={className} ref={onMount} dangerouslySetInnerHTML={{__html: inner + inner }} />
  );
});

function onMount(element) {
  if (element) {
    element.style.setProperty('--count', filter(element.childNodes, 'tagName').length/2);
  }
}
